(() => {
  if (window.SlackYardPdp2026) return;

  const api = {};

  function getMainButton() {
    return document.querySelector('.productAdd');
  }

  function getMainPrice() {
    return document.querySelector('.priceHolder .productPrice');
  }

  function copyProductState(root) {
    const mainButton = getMainButton();
    const mainPrice = getMainPrice();
    const buttons = root.querySelectorAll('[data-sypdp-atc]');

    buttons.forEach((button) => {
      if (!(button instanceof HTMLButtonElement) || !mainButton) return;
      const soldOut = mainButton.disabled || mainButton.classList.contains('is-soldout') || !mainButton.getAttribute('prid');
      button.disabled = soldOut;
      button.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      button.dataset.variantId = mainButton.getAttribute('prid') || '';
    });

    if (mainPrice) {
      root.querySelectorAll('[data-sypdp-live-price]').forEach((price) => {
        price.innerHTML = mainPrice.innerHTML;
      });
    }
  }

  function activateCartButton(button) {
    const mainButton = getMainButton();
    if (mainButton && !mainButton.disabled && mainButton.getAttribute('prid')) {
      mainButton.click();
      return;
    }

    const variantId = button.dataset.variantId || button.dataset.defaultVariant;
    if (!variantId || button.disabled) return;

    if (typeof window.addToCart === 'function') {
      window.addToCart(variantId);
      return;
    }

    fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to add item');
        return response.json();
      })
      .then(() => {
        if (window.liquidAjaxCart?.update) window.liquidAjaxCart.update();
        document.body.classList.add('js-show-ajax-cart');
      })
      .catch(() => {
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      });
  }

  function observeProductState(root) {
    copyProductState(root);

    const mainButton = getMainButton();
    const mainPrice = document.querySelector('.priceHolder [data-gibbon-sd]') ? document.querySelector('.priceHolder') : getMainPrice();
    const observer = new MutationObserver(() => copyProductState(root));

    if (mainButton) observer.observe(mainButton, { attributes: true, childList: true, subtree: true });
    if (mainPrice) observer.observe(mainPrice, { attributes: true, childList: true, subtree: true, characterData: true });

    root._sypdpProductObserver = observer;
  }

  function initCartActions(root) {
    root.querySelectorAll('[data-sypdp-atc]').forEach((button) => {
      if (button.dataset.sypdpBound === 'true') return;
      button.dataset.sypdpBound = 'true';
      button.addEventListener('click', () => activateCartButton(button));
    });
  }

  function initSticky(root) {
    if (root.dataset.sypdpReady === 'true') return;
    root.dataset.sypdpReady = 'true';

    const originalButton = getMainButton();
    const backToTop = root.querySelector('[data-sypdp-back-top]');

    initCartActions(root);
    observeProductState(root);

    const updateVisibility = () => {
      if (!originalButton) {
        root.classList.toggle('is-visible', window.scrollY > 520);
        root.setAttribute('aria-hidden', window.scrollY > 520 ? 'false' : 'true');
        return;
      }

      const rect = originalButton.getBoundingClientRect();
      const visible = rect.bottom < 0;
      root.classList.toggle('is-visible', visible);
      root.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    if (backToTop) {
      backToTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    }
  }

  function initFinal(root) {
    if (root.dataset.sypdpReady === 'true') return;
    root.dataset.sypdpReady = 'true';
    initCartActions(root);
    observeProductState(root);
  }

  function initFeatures(root) {
    if (root.dataset.sypdpReady === 'true') return;
    root.dataset.sypdpReady = 'true';

    const rail = root.querySelector('.sypdp-features__rail');
    const previous = root.querySelector('[data-sypdp-feature-prev]');
    const next = root.querySelector('[data-sypdp-feature-next]');
    if (!rail || !previous || !next) return;

    const scroll = (direction) => {
      const card = rail.querySelector('.sypdp-feature-card');
      const gap = Number.parseFloat(window.getComputedStyle(rail).columnGap) || 24;
      const distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.75;
      rail.scrollBy({
        left: direction * distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    previous.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-sypdp-sticky]').forEach(initSticky);
    scope.querySelectorAll('[data-sypdp-final]').forEach(initFinal);
    scope.querySelectorAll('.sypdp-features').forEach(initFeatures);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState !== 'loading') init();

  api.init = init;
  window.SlackYardPdp2026 = api;
})();
